// extracted by mini-css-extract-plugin
export default {"quote-container":"quote-container","quote-text":"quote-text","quote-author":"quote-author","mobile":"mobile"};